import { render, staticRenderFns } from "./login-verification-code.vue?vue&type=template&id=3fb70b7a&scoped=true";
import script from "./login-verification-code.vue?vue&type=script&lang=js";
export * from "./login-verification-code.vue?vue&type=script&lang=js";
import style0 from "./login-verification-code.vue?vue&type=style&index=0&id=3fb70b7a&prod&scoped=true&lang=css";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "3fb70b7a", null);
export default component.exports;